"use client";

import type React from "react";
import { createContext, use, useMemo, useTransition } from "react";

const defaultValue: {
  isPending: boolean;
  startTransition?: React.TransitionStartFunction;
} = { isPending: false };

const TransitionContext = createContext(defaultValue);

export const TransitionProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isPending, startTransition] = useTransition();
  const contextValue = useMemo(
    () => ({ isPending, startTransition }),
    [isPending]
  );

  return <TransitionContext value={contextValue}>{children}</TransitionContext>;
};

export const useSharedTransition = () => use(TransitionContext);
